import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Hidden } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

// components
import Modal from '../../../components/modal/Modal';
// img
import legendRainfall3day from '../../../assets/images/legend_rainfall3day.png';

const useStyles = makeStyles(styles);

export default function RainfallLegend3day() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [modalData, setModalData] = useState({
    open: false,
    header: t('เกณฑ์'),
    subheader: null,
    content: null,
  });
  const unmounted = useRef(false);

  const handleModal = () => (e) => {
    e.preventDefault();

    setModalData({
      open: true,
      header: t('เกณฑ์ฝนสะสม 3 วัน'),
      content: <Grid item xs><img src={legendRainfall3day} alt={t('เกณฑ์ฝนสะสม 3 วัน')} className={classes.img} /></Grid>,
    });
  };

  // force modal close
  useEffect(() => {
    if (modalData.open) modalData.open = false;
    return () => { unmounted.current = true; };
  }, [modalData.open]);

  function FormRow() {
    return (
      <>
        <Grid container direction="row" spacing={0}>
          <Grid item xs sm={2} md className={classes.boxLevel}>
            <Box>
              <Box display="flex">
                <Box p={0.5} width="50%" className={`${classes.color} ${classes.colorRain0}`}> </Box>
                <Box p={0.5} width="50%" className={`${classes.color} ${classes.colorRain1}`}> </Box>
                <Box p={0.5} width="50%" className={`${classes.color} ${classes.colorRain2}`}> </Box>
              </Box>
              <Box p={1} className={classes.title}>
                <Hidden smDown>{t('ฝนเล็กน้อย')}</Hidden>
                <Hidden mdUp>{t('ฝนน้อย')}</Hidden>
              </Box>
            </Box>
          </Grid>
          <Grid item xs sm md className={classes.boxLevel}>
            <Box display="flex">
              <Box p={0.5} width="50%" className={`${classes.color} ${classes.colorRain3}`}> </Box>
              <Box p={0.5} width="50%" className={`${classes.color} ${classes.colorRain4}`}> </Box>
            </Box>
            <Box p={1} className={classes.title}>{t('ฝนปานกลาง')}</Box>
          </Grid>
          <Grid item xs sm md className={classes.boxLevel}>
            <Box display="flex">
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain5}`}> </Box>
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain6}`}> </Box>
              <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain7}`}> </Box>
            </Box>
            <Box p={1} className={classes.title}>{t('ฝนหนัก')}</Box>
          </Grid>
          <Grid item xs sm={2} md className={classes.boxLevel} style={{ borderRight: '1px solid #ccc' }}>
            <Box>
              <Box display="flex">
                <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain8}`}> </Box>
                <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain9}`}> </Box>
                <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain10}`}> </Box>
                <Box p={0.5} width="100%" className={`${classes.color} ${classes.colorRain11}`}> </Box>
              </Box>
              <Box p={1} className={classes.title}>
                <Hidden smDown>{t('ฝนหนักมาก')}</Hidden>
                <Hidden mdUp>{t('ฝนมาก')}</Hidden>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs>
          <FormControl className={classes.formControl}>
            <Button variant="outlined" color="primary" size="small" className={classes.button} onClick={handleModal()} title={t('แสดงเกณฑ์')}>
              {t('แสดงเกณฑ์ฝน 3 วัน')}
            </Button>
          </FormControl>
        </Grid>
        <Modal
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
        />
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <FormRow />
      </Grid>
    </div>
  );
}
